import React, { useEffect, useState, useRef } from 'react';
import { onValue, ref, set } from 'firebase/database';
import { db } from '@react-native-firebase/database';
import { View, Text, TextInput, TouchableOpacity, Dimensions } from 'react-native';
import DropDownField from 'src/components/DropDownField';
import { MOBILE_VIEW_WIDTH } from 'res/constants';
import StyleSheetRW from 'core/StyleSheetRW';
import closeIcon from "res/img/cross.png";

interface Props {
    onPress: () => void;
    edit: boolean;
    role: string;
}

interface RoleData {
    technical: string[];
    communication: string[];
    interpersonal: string[];
    [key: string]: any;
}

const AddNewQuestionnaire: React.FC<Props> = ({ onPress, edit, role }) => {
    const [roles, setRoles] = useState<string[]>([]);
    const [selectedRole, setSelectedRole] = useState<string>("");
    const [skills, setSkills] = useState({
        technical : [],
        communication : [],
        interpersonal : []
    });
    const [newSkillCategory, setNewSkillCategory] = useState<string>("");
    const [newQuestions, setNewQuestions] = useState<{ [key: string]: string }>({});
    const [isCollapsed, setIsCollapsed] = useState<{ [key: string]: boolean }>({
        technical: true,
        communication: true,
        interpersonal: true
    });

    const inputRefs = useRef<{ [key: string]: TextInput }>({});

    useEffect(() => {
        const dbRef = ref(db, 'userRoles');
        const unsubscribe = onValue(dbRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const rolesList = Object.keys(data).map(key => data[key]);
                setRoles(rolesList);
            } else {
                console.log('No data available');
            }
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (edit === false) {
            setSelectedRole(role);
        }
    }, [edit, role]);

    useEffect(() => {
        if (selectedRole) {
            const dbRef = ref(db, `questionnaire/${selectedRole}`);
            const unsubscribe = onValue(dbRef, (snapshot) => {
                if (snapshot.exists()) {
                    const data = snapshot.val() as RoleData;

                    const fetchedSkills: { [key: string]: string[] } = {};
                    Object.keys(data).forEach(key => {
                        if (key !== 'title') {
                            fetchedSkills[key] = data[key];
                        }
                    });
                    setSkills(fetchedSkills);
                }
            });
            return () => unsubscribe();
        } else {
            setSkills({
                technical: [],
                communication: [],
                interpersonal: []
            });
        }
    }, [selectedRole]);

    const handleRoleChange = (value: string) => {
        setSelectedRole(value);
    };

    const addQuestion = (type: string) => {
        if (newQuestions[type]?.trim()) {
            setSkills({
                ...skills,
                [type]: [...(skills[type] || []), newQuestions[type].trim()]
            });
            setNewQuestions({
                ...newQuestions,
                [type]: ""
            });
            inputRefs.current[type]?.focus();
        }
    };

    const handleKeyPress = (type: string, event: any) => {
        if (event.nativeEvent.key === "Enter") {
            addQuestion(type);
        }
    };

    const deleteQuestion = (type: string, index: number) => {
        setSkills({
            ...skills,
            [type]: skills[type].filter((_, i) => i !== index)
        });
    };

    const deleteSkillCategory = (category: string) => {
        const updatedSkills = { ...skills };
        delete updatedSkills[category];
        setSkills(updatedSkills);
    };

    const saveData = () => {
        if (selectedRole) {
            const dbRef = ref(db, `questionnaire/${selectedRole}/`);
       
    
            set(dbRef, skills)
                .then(() => {
                    console.log("Data saved successfully.");
                })
                .catch((error) => {
                    console.error("Error saving data:", error);
                });
        } else {
            console.log("Title must be added before saving.");
        }
    };
    
    const addNewSkillCategory = () => {
        if (selectedRole && newSkillCategory.trim()) {
            const trimmedCategory = newSkillCategory.trim();
            setSkills(prevSkills => {
                const updatedSkills = {
                    ...prevSkills,
                    [trimmedCategory]: [""]
                };
                console.log("Updated skills:", updatedSkills); 
                return updatedSkills;
            });
            setIsCollapsed(prevIsCollapsed => ({
                ...prevIsCollapsed,
                [trimmedCategory]: true
            }));
            setNewSkillCategory("");
        } else {
            console.log("Please select a role and enter a skill category name.");
        }
    };


   
   
    const isDisabled = selectedRole === "";
    const screenWidth = Dimensions.get("window").width;
    return (
        <>
           
            <img src={closeIcon} alt="" style={styles.crossSign} onClick={()=>(onPress())} />
            <div style={{ display: "flex", flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? "column" : "row" }}>
                <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? "column" : "row" }}>
                        <View style={{ ...styles.inputContainer, width: "300px" }}>
                            <Text style={{ ...styles.label, marginTop: 5 }}>Please select a UserRole</Text>
                            <DropDownField
                                value={selectedRole}
                                placeholder="Please Select a Role"
                                placeholderTextColor={"rgb(109,126,124)"}
                                bodyStyle={{ marginHorizontal: 0 }}
                                options={roles}
                                onChangeText={handleRoleChange}
                                label="Role"
                                editable={edit}
                            />
                        </View>
                    </div>
                    {selectedRole&&<>
                     <View style={{ ...styles.inputContainer, flexDirection: "row", alignItems: "center" }}>
                        <TextInput
                            style={{ ...styles.textInput, width: "200px", height: "45px" }}
                            value={newSkillCategory}
                            onChangeText={setNewSkillCategory}
                            placeholder="Add New Skill Category"
                            placeholderTextColor={"#00000050"}
                            editable={!isDisabled}
                        />
                        <TouchableOpacity
                            onPress={addNewSkillCategory}
                        style={[styles.saveButton, isDisabled ? { backgroundColor: "gray" } : null,{width:"80px",marginLeft:10}]}
                        disabled={isDisabled}
                        >
                            <Text style={styles.saveButtonText}>Add</Text>
                        </TouchableOpacity>
                    </View>
                    {Object.keys(skills).map((skillCategory) => (
                        <View key={skillCategory} style={styles.inputContainer}>
                            <View style={{display:"flex",flexDirection:"row"}}>
                            <TouchableOpacity onPress={() => setIsCollapsed({ ...isCollapsed, [skillCategory]: !isCollapsed[skillCategory] })}>
                            <Text style={{ ...styles.label, fontWeight: "700", fontSize: 22 }}>
    {isCollapsed[skillCategory] ? '+' : '-'} {skillCategory.charAt(0).toUpperCase() + skillCategory.slice(1)} ({skills[skillCategory].filter(q => q.trim() !== "").length})
</Text>
                            </TouchableOpacity>
                            {selectedRole&&
                       
            <img src={closeIcon} alt="" style={styles.deleteCross} onClick={()=>(deleteSkillCategory(skillCategory))} />

                                                    }</View>
                            {!isCollapsed[skillCategory] &&
                                <View>
                                    
                                        {/* <TouchableOpacity
                                            onPress={() => deleteSkillCategory(skillCategory)}
                                            style={styles.deleteButton}
                                        >
                                            <Text style={{ color: "#ffffff" }}>Delete Category</Text>
                                        </TouchableOpacity> */}
                                    
                                    <TextInput
                                        ref={(el) => (inputRefs.current[skillCategory] = el)}
                                        style={styles.textInput}
                                        value={newQuestions[skillCategory] || ""}
                                        onChangeText={(text) => setNewQuestions({ ...newQuestions, [skillCategory]: text })}
                                        onKeyPress={(event) => handleKeyPress(skillCategory, event)}
                                        placeholder={`Enter a ${skillCategory} question`}
                                        placeholderTextColor={"#00000050"}
                                    />
                                    <View>
                                    {skills[skillCategory].filter(q => q.trim() !== "").map((question, index) => (
                        <View key={index} style={styles.questionContainer}>
                            <Text style={styles.questionText}>{index + 1}. {question}</Text>
                           
            <img src={closeIcon} alt="" style={styles.deleteCross} onClick={()=>(deleteQuestion(skillCategory, index))} />

                        </View>
                    ))}
                </View>
            </View>
        }
                        </View>
                    ))}

                   

                    <TouchableOpacity
                        style={[styles.saveButton, isDisabled ? { backgroundColor: "gray" } : null]}
                        disabled={isDisabled}
                        onPress={() => { saveData(); onPress(); }}
                    >
                        <Text style={styles.saveButtonText}>Save Questionnaire</Text>
                    </TouchableOpacity>
                    </>}
                </div>
                
            </div>
        </>
    );
};

const styles = StyleSheetRW.create(() => ({
    crossSign: { right: 55, position: "absolute", top: 18, cursor: "pointer", backgroundColor: '#ffffff', padding: 5, borderRadius: 20 ,},
    inputContainer: {
        marginVertical: 10,
    },
    deleteCross: { marginLeft:10, top: 10, cursor: "pointer", backgroundColor: '#ffffff', padding: 5, borderRadius: 20 ,width:15,height:15},
    label: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    cancelIconMobile:{ width: 24, height: 24, cursor: "pointer" },
    deleteButton: {
        backgroundColor: "#2F4858",
        paddingVertical: 10,
        paddingHorizontal: 10,
        borderRadius: 4,
        width: "125px",
        marginBottom: 10
    },
    textInput: {
        borderColor: '#ccc',
        borderWidth: 1,
        borderRadius: 5,
        padding: 10,
        fontSize: 16,
        color: '#000',
    },
    questionContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 10,
    },
    questionText: {
        fontSize: 16,
        color: '#000',
    },
    deleteText: {
        fontSize: 14,
        color: 'red',
    },
    saveButtonContainer: {
        marginTop: 20,
        alignItems: 'center',
    },
    saveButton: {
        backgroundColor: "#2F4858",
        paddingVertical: 10,
        paddingHorizontal: 15,
        borderRadius: 4,
        width: "190px"
    },
    saveButtonText: {
        fontSize: 18,
        color: '#fff',
        textAlign: "center"
    },
    separator: {
        borderBottomWidth: 1,
        borderBottomColor: '#2F4858',
    },
}));

export default AddNewQuestionnaire;
